<template>
  <dl class="ui-kv">
    <div v-for="row in rows" :key="row.key || row.label">
      <dt>{{ row.label }}</dt>
      <dd :class="{ 'is-empty': isEmpty(row) }">
        <slot name="value" :row="row">{{ row.value || emptyText }}</slot>
      </dd>
    </div>
  </dl>
</template>

<script>
/**
 * Podaci "naziv: vrijednost" u panelu. rows: [{ label, value, key?, empty? }]; prazna vrijednost se piše sivo (emptyText).
 * Slot `value` ({ row }) daje drugačiji prikaz vrijednosti (veza, dugme); tada red kaže `empty` sam.
 */
export default {
  name: "UiKv",
  props: {
    rows: { type: Array, required: true },
    emptyText: { type: String, default: "—" },
  },
  methods: {
    isEmpty(row) {
      return row.empty !== undefined ? row.empty : !row.value;
    },
  },
};
</script>
